import { If, createComponent } from '@lib/util/templateHelpers';
import shared from '@lib/components';
const { 
  Block,
  Flex,
  RouterLink
} = shared;

import styles from './index.module.scss';

const gameTileBlockStates = [
  'center'
];

const formatTitle = (title) => {
	if (typeof title === 'string') {
		return title.replace(/\s*games$/i, '');
	}
	return title;
};

export default createComponent('GameTileBlock', { classStates: gameTileBlockStates, styles }, function GameTileBlock ({ className, slots }, props) {
  return (
    <Block className={className}>
      <Flex className='GameTileBlock__Title' container gap0>
        <header>
          {slots.title}
        </header>
        {
          If(props.viewAllHref, () => (
            <>
              <Flex>
                <RouterLink href={props.viewAllHref}>View All</RouterLink>
              </Flex>
              <Flex pullRight>
                <RouterLink href={props.viewAllHref}>»</RouterLink>
              </Flex>
            </>
          ))
          .EndIf()
        }
      </Flex>
      <div className='GameTileBlock__Content'>
        <div className='GameTileBlock__ContentInner'>
          {slots.defaultSlot}
        </div>
      </div>
      {
        If(slots.control, () => (
          <div className='GameTileBlock__Control'>
            {slots.control}
          </div>
        ))
        .EndIf()
      }
	{If(slots.description, () => (
		<div className='GameTileBlock__Description Box IndexPage__BottomBox Theme--iogames'>
			<h2 className="Title Title--size4">
				About {formatTitle(slots.title.props.children[0])} Games
			</h2>
			<div className='Content GameTileBlock__Description' dangerouslySetInnerHTML={{ __html: slots.description }} />
	</div>
	)).EndIf()}
    </Block>
  )
});
